'use client'

import { FC } from 'react'

import { useGetPopularProductsQuery } from '@/screens/Product/api/productApiSlice'
import { TProduct } from '@/screens/Product/page/types/types'

import { ProductCard } from '@/widgets/ProductCard'
import { SectionElements } from '@/widgets/SectionElements'

import { ItemLoader } from '@/shared/ui/Skeletons/variants/ItemLoader/ItemLoader'

type Props = {
	title?: string
	className?: string
	skeletonCount?: number
}

/**
 * Self-fetching "popular products" carousel (data source: /home/hits via RTK Query).
 * Loads client-side and lazily, so it stays off the server render / TTFB critical path.
 * Shared by the empty cart and the empty compare screens.
 */
export const PopularProductsCarousel: FC<Props> = ({ title = 'Популярные товары', className, skeletonCount = 4 }) => {
	const { data, isLoading } = useGetPopularProductsQuery()

	const products: TProduct[] = []
	data?.data?.forEach(item => {
		if (item.PRODUCTS) products.push(...item.PRODUCTS)
	})

	if (isLoading) {
		return (
			<SectionElements title={title} className={className}>
				{Array.from({ length: skeletonCount }, (_, index) => (
					<ItemLoader key={index} />
				))}
			</SectionElements>
		)
	}

	if (products.length === 0) return null

	return (
		<SectionElements title={title} className={className}>
			{products.map(product => (
				<ProductCard key={product.ID} data={product} />
			))}
		</SectionElements>
	)
}
